module.exports = {"id":"dp2_1l3q2","text":"Interacting Through Digital Technologies","instructions":"Which option best reflects the reality-virtuality continuum?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_1l3q2-a1","text":"Digital and physical experiences can blend","score":3.7},{"id":"dp2_1l3q2-a2","text":"Virtual experiences replace reality","score":1.3},{"id":"dp2_1l3q2-a3","text":"Digital spaces are fully separate","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.1"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.1/l3q2.json
// module id = 993
// module chunks = 41